import { FC } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { Delete, InsertDriveFile } from '@mui/icons-material';
import { fileSizeLabelFormat } from '@util/fileSizeLabelFormat.ts';

interface DocumentsListItemProps {
  id: string;
  fileName: string;
  fileSize: number;
  deleteAction: (id: string) => void;
  lastItem: boolean;
  disabled: boolean;
  handleOpenPreviewFileModal: (id: string) => void;
}

export const DocumentsListItem: FC<DocumentsListItemProps> = ({
  id,
  fileName,
  fileSize,
  deleteAction,
  lastItem,
  disabled,
  handleOpenPreviewFileModal,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingY: 1,
        cursor: 'pointer',
        ':hover': {
          bgcolor: 'rgba(19, 63, 110, 0.1)',
        },
        borderBottom: theme =>
          lastItem ? 'unset' : `1px solid ${theme.palette.grey[300]}`,
      }}
      onClick={() => handleOpenPreviewFileModal(id)}
    >
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <InsertDriveFile sx={{ width: 32, height: 32 }} color='primary' />
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant='body2'>{fileName}</Typography>
          <Typography variant='caption' sx={{ color: 'text.secondary' }}>
            {fileSizeLabelFormat(fileSize)}
          </Typography>
        </Box>
      </Box>
      <IconButton
        onClick={event => {
          event.stopPropagation();
          event.preventDefault();
          deleteAction(id);
        }}
        disabled={disabled}
      >
        <Delete
          sx={{ height: 24, width: 24 }}
          color={disabled ? 'disabled' : 'error'}
        />
      </IconButton>
    </Box>
  );
};
